import React from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import * as constants from '../../containers/Authorization/constants';
import Header from '../Header';
import Segment from '../Segment';
import Grid from '../Grid';
import Item from '../Item';
import CalendarSmall from '../CalendarSmall';
import CalendarCheckbox from '../CalendarCheckbox';
import ShareCalendar from '../../containers/ShareCalendar';
import ReassignAppointment from '../../containers/ReassignAppointments';
import HasRole from '../HasRole';
import SubscriptionActive from '../SubscriptionActive';

import './styles.css';

const messages = defineMessages({
  hideAllCalendars: {
    id: 'repvisits.calendar.availability.hideAllCalendars',
    defaultMessage: 'Hide all calendars',
  },
  shareCalendar: {
    id: 'repvisits.calendar.availability.shareCalendar',
    defaultMessage: 'Share calendars',
  },
  reassignappointments: {
    id: 'repvisits.calendar.availability.reassignappointments',
    defaultMessage: 'Re-assign appointments',
  },
});

class CalendarLeftPanel extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    onDayClick: PropTypes.func.isRequired,
    onNavigate: PropTypes.func.isRequired,
    onReassignmentSuccess: PropTypes.func.isRequired,
    currentDate: PropTypes.instanceOf(Date),
    currentView: PropTypes.string,
    visibleEventTypes: PropTypes.object,
    filterEventType: PropTypes.func,
  };

  static defaultProps = {
    visibleEventTypes: {},
  };

  state = {
    showShareCalendarModal: false,
    showReassignAppointmentsModal: false }

  displayShareCalendarModal = () => {
    this.setState({ showShareCalendarModal: true });
  };

  hideShareCalendarModal = () => {
    this.setState({ showShareCalendarModal: false });
  };

  displayReassignAppointmentsModal = () => {
    this.setState({ showReassignAppointmentsModal: true });
  };

  hideReassignAppointmentsModal = () => {
    this.setState({ showReassignAppointmentsModal: false });
  };

  render() {
    const {
      onDayClick,
      currentDate,
      currentView,
      visibleEventTypes,
      filterEventType,
      onNavigate,
      children,
      onReassignmentSuccess,
    } = this.props;

    const { showShareCalendarModal, showReassignAppointmentsModal } = this.state;

    return (
      <Segment styleName="panel">
        <Grid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column textAlign="left">
              <CalendarSmall
                currentView={currentView}
                currentDate={currentDate}
                onDayClick={onDayClick}
                onNavigate={onNavigate}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="left">
              <Header size="large" styleName="key-header calendar">Calendars</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="left">
              <Header size="tiny" styleName="key-header auto">Automatic</Header>
              <CalendarCheckbox
                onClick={filterEventType}
                name="visit"
                display="In-person visits - Confirmed"
                checked={visibleEventTypes.visit}
              />
              <CalendarCheckbox
                onClick={filterEventType}
                name="virtual"
                display="Virtual visits - Confirmed"
                checked={visibleEventTypes.virtual}
              />
              <CalendarCheckbox
                onClick={filterEventType}
                name="fair"
                display="College Fairs - Confirmed"
                checked={visibleEventTypes.fair}
              />
              <CalendarCheckbox
                onClick={filterEventType}
                name="pending"
                display="Pending"
                checked={visibleEventTypes.pending}
              />
            </Grid.Column>
          </Grid.Row>
          <SubscriptionActive anyOf={constants.REP_VISITS_SUBSCRIPTION}>
            <Grid.Row>
              <Grid.Column textAlign="left">
                <HasRole anyOf={constants.ADMIN_ROLE}>
                  {showReassignAppointmentsModal && (
                  <ReassignAppointment
                    onClose={this.hideReassignAppointmentsModal}
                    onReassignmentSuccess={onReassignmentSuccess}
                  />
                  )}
                  <Item>
                    <Item.Content>
                      <Item.Header
                        data-cy="repVisits-calendar-reassignment-enabled"
                        tabIndex="0"
                        role="button"
                        href="#"
                        as="a"
                        onClick={this.displayReassignAppointmentsModal}
                      >
                        <FormattedMessage {...messages.reassignappointments} />
                      </Item.Header>
                    </Item.Content>
                  </Item>
                </HasRole>
                <Item styleName="sharecalendar">
                  <Item.Content>
                    <Item.Header
                      tabIndex="0"
                      data-cy="repVisits-share-calendar"
                      role="button"
                      href="#"
                      as="a"
                      onClick={this.displayShareCalendarModal}
                    >
                      <FormattedMessage {...messages.shareCalendar} />
                    </Item.Header>
                  </Item.Content>
                </Item>
              </Grid.Column>
            </Grid.Row>
          </SubscriptionActive>
          {children}
        </Grid>
        <ShareCalendar open={showShareCalendarModal} onClose={this.hideShareCalendarModal} />
      </Segment>
    );
  }
}

export default injectIntl(CalendarLeftPanel);
